import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Typography, Divider, Box } from "@mui/material";
import GeneralApiService from "../../../services/generalServices";
import translations from "../../../assets/locals/translations";
import "./SalesData.css";

const SalesData = () => {
  const navigate = useNavigate();
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations["en"];
  const generalServices = new GeneralApiService();
  const [categoryList, setCategoryList] = useState([]);
  const [enquiryTypes, setEnquiryTypes] = useState([]);

  const defaultCategories = [
    { label: t.delivered || "Delivered", type: "DELIVERY", color: "#6BCB77", value: 2 },
    { label: t.invalid || "Invalid", type: "INVALID", color: "#9E9E9E", value: 2 },
    { label: t.lost || "Lost", type: "LOST", color: "#B71C1C", value: 2 },
  ];
  const getCategoryList = async () => {
    try {
      await generalServices.getCategoryList().then((response) => {
        if (response && response.isSuccess) {
          const updatedCategory = response.result
            .filter((val) => ![1, 2, 3].includes(val.value))
            .map((val, index) => {
              const existingType = enquiryTypes.find(
                (type) => type.label === val.label
              );
              return {
                label: getCategoryTranslation(val.label),
                value: val.value,
                type: existingType?.type || generateTypeFromLabel(val.label),
                color: "#525E75",
              };
            });

          // setEnquiryTypes((prevTypes) => [...prevTypes, ...updatedCategory]);
          // Combine default categories with API categories and filter out duplicates (by label)
          const mergedCategories = [...defaultCategories, ...updatedCategory];
          const uniqueCategories = mergedCategories.filter(
            (cat, index, self) =>
              index === self.findIndex((t) => t.label === cat.label)
          );
          setEnquiryTypes(uniqueCategories);
        }
      });
    } catch (error) {
      console.log(error, "Error getting category");
    }
  };

  // Function to generate a type from the label
  const generateTypeFromLabel = (label) => label.split(" ")[0].toUpperCase();

  // Function to generate random colors for dynamic entries
  const generateRandomColor = (index) => {
    const colors = [
      "#FF5733",
      "#33FF57",
      "#3357FF",
      "#FF33A1",
      "#A133FF",
      "#33FFF4",
    ];
    return colors[index % colors.length];
  };

  useEffect(() => {
    getCategoryList();
  }, []);

  const getCategoryTranslation = (label) => {
    const labelLower = label.toLowerCase().replace(/\s+/g, "").replace(/-/g, "");
    const translationKey = labelLower === "itlcustomer" ? "itlcustomer" :
      labelLower === "ssp" ? "ssp" :
        labelLower === "vfs" ? "vfs" :
          labelLower === "karigar" ? "karigar" :
            labelLower === "agrolavardukan" ? "agrolavar" :
              labelLower === "brokar" ? "brokar" :
                labelLower === "bagayat" ? "bagayat" :
                  labelLower === "sabsidi202526aplay" ? "sabsidi" :
                    null;
    return translationKey ? (t[translationKey] || label) : label;
  };

  const formatType = (type) =>
    type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();

  const handleNavigation = (stage) => {
    const formattedType = formatType(stage.type);
    navigate(`/sale/data/${formattedType}`, { state: { stage } });
  };

  return (
    <div className="sales-data-wrapper bg-white">
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold", mr: 2 }}>
          {t.dataoverview || "Data Overview"}
        </Typography>
        <Box sx={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
      </Box>
      <div className="sales-data-grid">
        {enquiryTypes.map(({ label, type, color, value }) => (
          <div
            key={type}
            className="sales-data-card"
            style={{ borderLeft: `4px solid ${color}` }}
            onClick={() => handleNavigation({ type, value })}
          >
            <div className="sales-data-card-content">
              <div className="sales-data-text">
                <h3 className="sales-data-label" style={{ color }}>
                  {label}
                </h3>
                {/* If you need any subtext description, add a <p> element here */}
              </div>
              <span className="sales-data-icon" style={{ color }}>
                <ChevronRightIcon sx={{ fontSize: 32 }} />
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SalesData;
